import type { TComponent } from 'utils/types/component';

import { columns } from 'components/domains/BalanceTableRedesign/columns';

import type { TBalance } from 'models/Merchant/Balance';

import { TableContent } from '../TableContent';

interface IDepositContentProps {
    item: TBalance;
}

export const DepositContent: TComponent<IDepositContentProps> = ({ item }) => {
    return (
        <TableContent
            data={item.paymentMethods}
            columns={columns.depositColumns}
            rowKey={(record) => record.formViewName}
        />
    );
};
